// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"45":"218f7e48","97":"28721637","140":"4f02f17e","482":"9988a399","884":"a61bff40","908":"e3a47bb6"}[chunkId] + ".css";
};